import { Layout } from '../Layout/Layout';

import { LoadingIndicator } from './LoadingIndicator';
import { suspenseLoadingStyles as sx } from './SuspenseLoading.styles';

export const SuspenseLoading = () => {
	return (
		<Layout fullHeightMainContent customSx={sx.root}>
			<LoadingIndicator color='orange' />
		</Layout>
	);
};
